import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  border-radius: 1.25rem;
  background-color: ${(props: any) =>
    props.variant === "primary" ? "#351182" : "#FFFFFF"};
  color: ${(props: any) =>
    props.variant === "primary" ? "#FFFFFF" : "#434343"};
  box-shadow: 0px 0px 19px 0px rgba(139, 139, 139, 0.25);
  margin: 3em 0;
  padding: 3em 1.5em;
  display: flex;
  flex-direction: row;

  div:first-child {
    margin-right: 1.5em;
    width: 45%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  div:last-child {
    width: 55%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    h1 {
      margin-bottom: 1.5em;
      font-family: Poppins;
      font-size: 1.5rem;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
    }
    p {
      margin-bottom: 1.5em;
      font-family: Poppins;
      font-size: 1.125rem;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
  }

  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    margin: 1.87em 0;
    flex-direction: column;
    text-align: center;
    div:first-child {
      margin-right: 0;
      /* margin-left: 20em; */
      width: 100%;
      margin-bottom: 1.5em;
    }
    div:last-child {
      width: 100%;
    }
  }
`;
